import Vue from 'vue'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async post ({ commit, dispatch }, { url, data }) {
      let response = {
        success: true,
        data: null
      }
      try {
        const serverResponse = await Vue.axios.post(url, data)
        if (serverResponse.data.success) {
          response.data = serverResponse.data.data
        } else {
          await dispatch('systemMessages/error', serverResponse.data.errors, { root: true })
          response.success = false
        }
      } catch (e) {
        console.log(e.response)
        await dispatch('systemMessages/handleError', e, { root: true })
        response.success = false
      }
      return response
    },
    async get ({ commit, dispatch }, { url }) {
      let response = {
        success: true,
        data: null
      }
      try {
        const serverResponse = await Vue.axios.get(url)
        if (serverResponse.data.success) {
          response.data = serverResponse.data.data
        } else {
          await dispatch('systemMessages/error', serverResponse.data.errors, { root: true })
          response.success = false
        }
      } catch (e) {
        console.log(e)
        await dispatch('systemMessages/handleError', e, { root: true })
        response.success = false
      }
      return response
    },
    async delete ({ dispatch }, { url, data }) {
      let response = {
        success: true,
        data: null
      }
      try {
        const serverResponse = await Vue.axios.delete(url, { params: data })
        if (serverResponse.data.success) {
          response.data = serverResponse.data.data
        } else {
          await dispatch('systemMessages/error', serverResponse.data.errors, { root: true })
          response.success = false
        }
      } catch (e) {
        console.log(e)
        await dispatch('systemMessages/handleError', e, { root: true })
        response.success = false
      }
      return response
    }
  },
  getters: {}
}
